import { createElement } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from 'shared/stores';
import type { UserRole } from 'types/user';
import type { IMenuItem, TAntMenuItem } from './types';

export const useGetItems = (items: IMenuItem[]) => {
  const { user } = useAuthStore();

  if (!user) return [];

  return transformItemsObjToItems(items, user?.role);
};

const transformItemsObjToItems = (itemsObj: IMenuItem[], userRole: UserRole): TAntMenuItem[] => {
  const items: TAntMenuItem[] = [];

  itemsObj.forEach(({ label, path, icon, children, allowedRoles }) => {
    let isAllowedItem: boolean = true;

    if (allowedRoles) {
      isAllowedItem = allowedRoles.includes(userRole);
    }

    if (!isAllowedItem) {
      return;
    }

    const labelElement = !children?.length ? createElement(Link, { to: path }, label) : label;

    items.push({
      key: path,
      icon: icon && createElement(icon),
      label: labelElement,
      children: children ? transformItemsObjToItems(children, userRole) : undefined,
    });
  });

  return items;
};
